///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.vendor_name_change = abcsetup.vendor_name_change || {};
abcsetup.vendor_name_change.workflow = abcsetup.vendor_name_change.workflow || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.vendor_name_change.workflow = {
    // Variables
    workflow_task: null,

    /**
     *
     */
    init: function () {
        abcsetup.setTitle('Vendor Name Change');

        // Assign the local workflow_task var
        this.workflow_task = JSON.parse($('#WorkflowTask').val());

        // Reject button clicked
        $('#reject-btn, .reject-btn.required').on('click', function () {
            return abcsetup.vendor_name_change.workflow._rejectItem($(this));
        });

        // Bind the reject dropdown events
        this._bindRejectDropdown();

        // Bind any form element behavior
        this._bindFormElems();
    },

    /**
     * Bind the reject dropdown events
     */
    _bindRejectDropdown: function () {
        $('.dropdown-menu.reject input.checkbox').prop('checked', false);

        $(document).on('click', '.dropdown-menu.reject', function (event) {
            event.stopPropagation();
        });

        $(document).on('click', '.dropdown-menu.reject input.checkbox', function () {
            if ($(this).prop('checked')) {
                $(this).closest('div.checkbox').find('textarea').show();
            } else {
                $(this).closest('div.checkbox').find('textarea').hide().next('.errorMsg').remove();
            }
        });
    },

    /**
     * Reject the item
     */
    _rejectItem: function (btn) {
        //const rejectReasonField = $('textarea[name="reject_reason"].required') || $('textarea[name="reject_reason_text[other]"].required');
        const rejectReasonField = $('textarea[name="reject_reason"].required');

        if (!rejectReasonField.val()) {
            rejectReasonField.addClass('error');
            return false;
        }

        btn.unbind('click').attr('type', 'submit').trigger('click');
    },

    /**
     * Bind any form element behavior
     */
    _bindFormElems: function () {
        if (this.workflow_task.task == 'brand_rep_fivek_check_received' || this.workflow_task.task == 'consumer_rep_onek_check_received') {
            $('#app_models_vendor__fivek_check_received').bind('change', function () {
                $('.btn-success[value="approve"]').attr('disabled', true);
                if ($(this).val() == 1) {
                    $('.btn-success[value="approve"]').attr('disabled', false);
                }
            }).trigger('change');
        }

        // Credit team approved with business to determine approval
        $(document).on('click', '#risky-approval-btn', function () {
            abcsetup.alerts.prompt('Allow the business to determine approval', 'Please add a comment to continue with approval:', function (resp) {
                if (resp[0] == true) {
                    $('#app_models_vendor__risky_comment').val(resp[1]);
                    $('#normal-approval-btn').trigger('click');
                }
            }, true);
        });

        // Remit To Country changed
        $('#app_models_vendor_contact_remit_to_contact_remit_to_contact_country').bind('change', function() {
            $('#app_models_vendor_contact_remit_to_contact_remit_to_contact_zip_code').unmask().attr('placeholder', '')

            // Validate zip codes in the US
            if ($(this).val() == 'US') {
                $('#app_models_vendor_contact_remit_to_contact_remit_to_contact_zip_code').mask("99999").attr('placeholder', 'XXXXX')
            }
        }).trigger('change');


        // Signature invite button
        $(document).on('click', '.btn-signature-invite', function (event) {
            var _link = $(this);
            _link.css("cursor", "progress");

            axios.post('/api/new_vendor/send_signature', {
                'tag': _link.data('field-tag'),
                'column': _link.data('field-column'),
                'email': _link.closest('.row').find('input').val(),
                'workflow_task_id': abcsetup.vendor_name_change.workflow.workflow_task.id,
            }).then(response => {
                _link.css('cursor', 'pointer');
                abcsetup.alerts.show('Signature Email Sent', 'We\'ve sent a signature request email to the address you specified.');
            });
        });

        // Toggle the Confidential checkboxes for Net Worth and Annual sales if Private business (credit eval)
        $(document).on('change', '#app_models_vendor__is_public', function () {
            if ($('#app_models_vendor__is_public').val() == '0') {
                $('#app_models_vendor__net_worth_confidential').parent().show();
                $('#app_models_vendor__annual_sales_confidential').parent().show();
            } else {
                $('#app_models_vendor__net_worth_confidential').parent().hide();
                $('#app_models_vendor__annual_sales_confidential').parent().hide();
            }
        });

        // Labeler Codes
        $(document).on('change keyup', 'div.labeler_codes input', function() {
            var blankRow = false;

            $('.labeler_codes').each(function() {
                if ($(this).find('input').filter(function() { return $(this).val() === ''; }).length == 3) {
                    blankRow = true;
                }
            })

            if (!blankRow) {
                var row = $('.labeler_codes:last').clone();
                row.find('input').val('').attr('required', false).attr('requiredIf', '').removeClass('invalid');

                // Apply a uid to the 2 fields and make them dependant on eachother
                var id = abcsetup.randomString();
                row.find('input.LabelerCodes_number').attr('id', 'LabelerCodes_number' + id);
                row.find('input.LabelerCodes_effective_date').attr('id', 'LabelerCodes_effective_date' + id).attr('requiredIf', 'LabelerCodes_number' + id + '!=');
                row.find('input.LabelerCodes_expiration_date').attr('id', 'LabelerCodes_expiration_date' + id).attr('requiredIf', 'LabelerCodes_number' + id + '!=');
                row.find('small').remove();
                $('.labeler_codes:last').after(row);
            }
        });

        $('.labeler_codes input').eq(0).trigger('change');
    },

}
